module.exports = __webpack_public_path__ + "static/sponsor-humana-b54d3c8aee70ebe6b2089edc91c2324d.jpg";